import { render, staticRenderFns } from "./EditGameleoKeyword.vue?vue&type=template&id=4fdb3e23&scoped=true&"
import script from "./EditGameleoKeyword.vue?vue&type=script&lang=js&"
export * from "./EditGameleoKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdb3e23",
  null
  
)

export default component.exports